<template>
  <div class="betTakenModal">
    <div class="header">
      <p class="title">{{ $t('flipCoinBetTakenTitle') }}</p>
      <img class="close" src="/img/icons/bone_close.svg" alt="close" @click="getOut" />
    </div>
    <p class="description">
      {{ $t('flipCoinBetTakenDescription') }}
    </p>
    <TavernFlipCoinBigButton class="placeBetBtn" :label="$t('OK')" @click="getOut" />
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['get-out']);

const getOut = () => {
  emit('get-out');
};
</script>

<style lang="scss" scoped>
.betTakenModal {
  width: 461px;
  height: 318px;
  border-radius: 12px;
  background: linear-gradient(to bottom, #4e3127, #000000);
  margin: 0 auto;
  padding-top: 7px;
  margin-top: 7%;
  z-index: 9999;
  position: absolute;
  left: 25%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 20px;
  border: 1px solid #483b20;

  @media screen and (max-width: 479px) {
    width: 99vw;
    margin-top: 0;
    left: 0;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: -5px 20px;

  .title {
    font-size: 24px;
    line-height: 48px;
    font-weight: 500;
    color: #f6164c;
    max-width: 80%;
    margin: 0 auto;
    font-family: Grenze, sans-serif;
    text-align: center;
  }

  .close {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.description {
  font-size: 20px;
  line-height: 120%;
  font-weight: 500;
  color: #fff;
  margin: 0 20px;
  text-align: center;
  font-family: Eczar, sans-serif;
}
</style>
